import { api } from '@/lib/api';

export type AdditionalService = {
  id: string;
  hospitalId: string;
  name: string;
  defaultPrice: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
};

export const additionalServicesApi = {
  list: (params?: { includeInactive?: boolean }) =>
    api.get('/api/additional-services', { params }),
  create: (data: { name: string; defaultPrice?: number }) =>
    api.post('/api/additional-services', data),
  update: (id: string, data: { name?: string; defaultPrice?: number; isActive?: boolean }) =>
    api.patch(`/api/additional-services/${id}`, data),
};
